import { render } from "./OidcCallback.vue?vue&type=template&id=3d3ceb46"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Unifi.Web\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__